/* eslint-env browser */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import AUNewPasswordComponent from '@aarhus-university/au-lib-react-components/src/components/password/AUNewPasswordComponent';
import AUPasswordRequirementsComponent from '@aarhus-university/au-lib-react-components/src/components/password/AUPasswordRequirementsComponent';
import { validatePassword, isPwned } from '@aarhus-university/au-lib-react-components/src/lib/validation';
import { useAUPassword, useAUPasswordValidation } from '@aarhus-university/au-lib-react-components/src/components/password/AUPasswordHooks';
import { PATCH_PASSWORD } from '@aarhus-university/au-lib-react-components/src/components/password/AUPasswordActions';
import { passwordLabels } from '@aarhus-university/au-lib-react-components/src/lib/i18n';
import AUReceiptComponent from '@aarhus-university/au-lib-react-components/src/components/form/AUReceiptComponent';
import UrlHandler from '@aarhus-university/au-lib-react-components/src/lib/urlHandler';
import { ACTIVATE_PASSWORD } from '../actions/const';

const getLangPart = (lang) => lang.substring(0, 1).toUpperCase() + lang.substring(1);

const ChangePasswordComponent = ({
  saving,
  saved,
  validToken,
  patchPassword, // kommer fra comp-lib
  onSaveAction,
  checkUserTokenIsValid, // kommer fra comp-lib
  getContext,
  onCheckForTokenAction,
  dismissMessages,
  messages,
  context,
}) => {
  const [,
    { newPassword, setNewPassword },
    { confirmPassword, setConfirmPassword },
  ] = useAUPassword();

  const [,
    {
      newPasswordValidated,
      setNewPasswordValidated,
      newPasswordValidationMessages,
      setNewPasswordValidationMessages,
    },
    {
      confirmPasswordValidated,
      setConfirmPasswordValidated,
      confirmPasswordValidationMessages,
      setConfirmPasswordValidationMessages,
    },
  ] = useAUPasswordValidation();

  let userToken = null;
  let contextKey = null;
  const parsedQuery = UrlHandler.parse();
  if (parsedQuery) {
    const { userToken: token, context: contextQuery } = parsedQuery;
    userToken = token;
    contextKey = contextQuery;
  }

  if (contextKey) {
    passwordLabels.da.changePassword = 'Vælg adgangskode';
    passwordLabels.en.changePassword = 'Select your password';
    passwordLabels.da.changePasswordInfo = 'Dit password gælder til alle Aarhus Universitets systemer.';
    passwordLabels.en.changePasswordInfo = 'Your password will apply to all Aarhus University systems.';
    passwordLabels.da.newPassword = 'Skriv adgangskode';
    passwordLabels.en.newPassword = 'Enter password';
    passwordLabels.da.newPasswordInfo = 'Af sikkerhedsmæssige årsager må adgangskoden ikke indeholde personlige oplysninger.';
    passwordLabels.en.newPasswordInfo = 'For security reasons, the password may not contain personal information.';
    passwordLabels.da.repeatPassword = 'Gentag adgangskode';
    passwordLabels.en.repeatPassword = 'Confirm password';
  }

  useEffect(() => {
    checkUserTokenIsValid(userToken || '', onCheckForTokenAction);
    if (contextKey) {
      getContext(contextKey);
    }
  }, []);

  const handleChangePassword = () => {
    validatePassword(
      window.appLang,
      newPassword,
      confirmPassword,
      false,
      true,
      isPwned,
      passwordLabels[window.appLang].pwned,
    ).then(
      (v) => {
        setNewPasswordValidated(v.newPasswordValid);
        setNewPasswordValidationMessages(v.newPasswordMessages);
        setConfirmPasswordValidated(v.confirmPasswordValid);
        setConfirmPasswordValidationMessages(v.confirmPasswordMessages);
        if (v.newPasswordValid && v.confirmPasswordValid) { // && userToken) {
          const endpoint = '/V1/User/SetPassword';
          const type = PATCH_PASSWORD;
          patchPassword(endpoint, type, userToken || '', {
            password: newPassword,
          }, onSaveAction, window.appLang);
        }
      },
    );
  };

  if (!validToken) {
    return (
      <div className="page__content__block">
        <h1>{passwordLabels[window.appLang].expiredHeader}</h1>
        <p>{passwordLabels[window.appLang].expiredText}</p>
        {
          contextKey && (
            <a className="button" href={`/${window.appLang}/help`}>{passwordLabels[window.appLang].supportHeader}</a>
          )
        }
        {
          !contextKey && (
            <a className="button" href={`/${window.appLang}/password/forgot`}>{passwordLabels[window.appLang].expiredLink}</a>
          )
        }
      </div>
    );
  }

  if (saved) {
    if (context) {
      return (
        <div className="page__content__block">
          <AUReceiptComponent
            receiptText={context[`activationSuccessText${getLangPart(window.appLang)}`]}
            showGoTo
            buttons={[{
              gotoText: context[`activationReturnText${getLangPart(window.appLang)}`],
              gotoLink: context[`activationReturnUrl${getLangPart(window.appLang)}`],
            }]}
          />
        </div>
      );
    }

    return (
      <div className="page__content__block">
        <AUReceiptComponent
          receiptText={passwordLabels[window.appLang].receipt}
          showGoTo={false}
        />
      </div>
    );
  }

  return (
    <div className="page__content__block">
      <h1>{passwordLabels[window.appLang].changePassword}</h1>
      <p>{passwordLabels[window.appLang].changePasswordInfo}</p>
      <form
        className="form"
        noValidate="novalidate"
        onSubmit={(e) => {
          e.preventDefault();
          handleChangePassword();
        }}
      >
        <div className="row row--wrap-reverse row--equal-height-items">
          <AUNewPasswordComponent
            lang={window.appLang}
            saving={saving}
            errorMessages={messages.map((x) => x.message)}
            setErrorMessages={dismissMessages}
            newPassword={newPassword}
            newPasswordValidated={newPasswordValidated}
            newPasswordValidationMessages={newPasswordValidationMessages}
            setNewPassword={setNewPassword}
            setNewPasswordValidated={setNewPasswordValidated}
            setNewPasswordValidationMessages={setNewPasswordValidationMessages}
            confirmPassword={confirmPassword}
            confirmPasswordValidated={confirmPasswordValidated}
            confirmPasswordValidationMessages={confirmPasswordValidationMessages}
            setConfirmPassword={setConfirmPassword}
            setConfirmPasswordValidated={setConfirmPasswordValidated}
            setConfirmPasswordValidationMessages={setConfirmPasswordValidationMessages}
          />
          <AUPasswordRequirementsComponent lang={window.appLang} />
        </div>
      </form>
    </div>
  );
};

ChangePasswordComponent.displayName = 'ChangePasswordComponent';

ChangePasswordComponent.defaultProps = {
  onSaveAction: async (endpoint, type, userToken, data, callback) => {
    const url = `${endpoint}?userToken=${userToken}`;
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    let json = null;
    // Hvis vil har en fejl ELLER vi kommer fra brugeroprettelsestilstand
    if (!response.ok || type === ACTIVATE_PASSWORD) {
      json = await response.json();
    }
    // Hvis vi kommer fra "almindelig" passwordskifte
    if (response.ok && type === PATCH_PASSWORD) {
      json = true;
    }
    callback(response.ok, response.status, json, type);
  },
  onCheckForTokenAction: async (userToken, callback) => {
    const url = `/V1/User/CheckUserTokenIsValid?userToken=${userToken}`;
    const response = await fetch(url);
    callback(response.ok, response.status);
  },
};

ChangePasswordComponent.propTypes = {
  saving: PropTypes.bool.isRequired,
  saved: PropTypes.bool.isRequired,
  validToken: PropTypes.bool.isRequired,
  context: PropTypes.shape({
    auid: PropTypes.number.isRequired,
  }).isRequired,
  patchPassword: PropTypes.func.isRequired,
  onSaveAction: PropTypes.func,
  checkUserTokenIsValid: PropTypes.func.isRequired,
  getContext: PropTypes.func.isRequired,
  onCheckForTokenAction: PropTypes.func,
  dismissMessages: PropTypes.func.isRequired,
  messages: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  })).isRequired,
};

export default ChangePasswordComponent;
